import type { ReactNode } from "react";
import { useEffect } from "react";
import { controller } from "./service/controller";
import { useWorkspace } from "@/context/workspace";

/**
 * Mount this provider around screens that call `useRunControl`.
 * The hook itself reads from a global Zustand store, but the provider
 * handles workspace-driven and unmount resets so consumers stay in sync
 * with the active workspace lifecycle.
 */
export function RunControlProvider({ children }: { children: ReactNode }) {
  const { wsChangeCount } = useWorkspace();

  useEffect(() => {
    controller.reset();
  }, [wsChangeCount]);

  useEffect(() => () => controller.reset(), []);

  return <>{children}</>;
}
